const initialPointerCoordinates = {
  x: 0,
  y: 0,
};

export default initialPointerCoordinates;
